import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const PoliciesProcedures: React.FC = () => {
  const sections = [
    {
      title: 'Security Policies & Procedures Development',
      content: 'Our expert consultants develop comprehensive security policies and procedures tailored to your organization\'s specific needs, industry requirements, and regulatory obligations. We create practical, enforceable policies that strengthen your security posture while enabling business operations.',
      benefits: [
        'Comprehensive policy framework development',
        'Industry-specific compliance alignment',
        'Risk-based policy prioritization',
        'Stakeholder consultation and review',
        'Implementation guidance and training'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Policies & Procedures"
      subtitle="Expert development of comprehensive security policies and procedures to strengthen governance and ensure compliance."
      sections={sections}
    />
  );
};

export default PoliciesProcedures;

